import Endpoints from '@/config/ApiEndpoints.js';	
import Axios from 'axios';
import $ from 'jquery'; 
var moment = require("moment");
export default {
	props:['VehicleId'],
	components:{
	},
	filters: {
        date: function(data) {
			var sendDate = "N/A";
			if (data != "" && data != null) {
			sendDate = moment(data).format("DD-MM-YYYY");
			}
			return sendDate;
        }	
    },
	data() {
		return {
			DocumentList: [],
			brake_check_excel_data:[],
			ShowLoader:false,
			Category:"vehicle",
			SubCategory:"brakes",
		};
	},		
	mounted() {		
		this.GetDocumentList();	
	},
	
	methods : { 
	GetDocumentList() {
		this.ShowLoader = true;
		var obj = {
			token: localStorage.getItem("token"),
			page: 1,
			category: this.Category,
			sub_category: this.SubCategory,
			vehicle_id: this.VehicleId,
		};
		
		Axios.post(Endpoints.Dcoument.DocumentPagination, obj).then(
			(Response) => {
				this.ShowLoader = false;
				if (Response?.data?.success) {
					this.DocumentList = {
					documents: Response.data.documents,
					page: 1,
					last_page: Response.data.documents.last_page,
					};

					this.brake_check_excel_data = [];
					if (this.DocumentList.documents.data.length > 0) {
						this.DocumentList.documents.data.forEach((element) => {
							var obj = {};
							obj["Title"] = element.title;
							obj["Date"] = element.fields.date.value;
							obj["Next Date"] = element.fields.next_date.value;
							this.brake_check_excel_data.push(obj);
						});
					}
				}
			}
			
		);
		},
		ViewAll(currentPage) {
			this.ShowLoader = true;
		var nextPage = currentPage + 1;
		var obj = {
			token: localStorage.getItem("token"),
			page: nextPage,
			category: this.Category,
			sub_category: this.SubCategory,
			vehicle_id: this.VehicleId,
		}; 
		Axios.post(Endpoints.Dcoument.DocumentPagination, obj).then(
			(Response) => {
			if (Response?.data?.success) {
				this.ShowLoader = false;
				this.DocumentList.page = nextPage;
				this.DocumentList.last_page =
				Response.data.documents.last_page;
				Response.data.documents.data.forEach((element) => {
				this.DocumentList.documents.data.push(
					element
				);
				});
			}
			}
		);
		},
		ViewDocumentFile(files) {
			this.$swal.fire({
				title: "Downloading...",
				text: "Please wait...",
				showConfirmButton: false,
				allowOutsideClick: false,
			});
			Axios.post(Endpoints.File.Get, {
				token: localStorage.getItem("token"),
				file: files,
			}).then((Response) => {
				if (Response?.data?.success == true) {
				this.$swal.close();
				window.open(Response.data.file, "_blank");
				} else {
				this.$swal
					.fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
					.then(() => {});
				}
			});
		},
        
	},
}
